import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class HeaderService {
  public closeSearchEmitter: BehaviorSubject<boolean>;

  constructor() {
    this.closeSearchEmitter = new BehaviorSubject<boolean>(false);
  }

  public emitCloseSearch() {
    this.closeSearchEmitter.next(false);
  }

}
